import { NewLog } from '../types'

interface PrepareCopiedLogOptions {
  date: string
  professorUID: string
  uid: string
}

export const prepareCopiedLog = (
  sourceLog: NewLog,
  { date, professorUID, uid }: PrepareCopiedLogOptions,
): NewLog => {
  const copiedLog = { ...sourceLog }

  delete copiedLog.audio

  return {
    ...copiedLog,
    date,
    professorUID,
    uid,
  }
}
